export default {
    sortedItems: function(state) {
        function compare(a, b) {
          if (a.Symbol < b.Symbol)
            return -1;
          if (a.Symbol > b.Symbol)
            return 1;
          return 0;
        }
    
        return state.items ? state.items.sort(compare) : [];
    },
    selectedItems(state){
      return state.items.filter(o=>o.selected);
    },
    allSelected(state) {
      return state.items.every(o=>o.selected);
    },
    noneSelected(state) {
      return !state.items.some(o=>o.selected);
    }
}
